/* ============================================================
   PM WISHLIST — localStorage backend (loaded site-wide)
   ============================================================
   Storage key: 'pm:wishlist:saved'
   Shape:       Array of product objects:
                  { id, title, handle, url, image, price, variantId }

   Markup contract:
     • [data-wishlist-toggle] data-product-id="..."
        data-product-title="..." data-product-handle="..."
        data-product-url="..." data-product-image="..."
        data-product-price="..." data-variant-id="..."
       Toggle saves/removes; sets aria-pressed.
     • #nav-wishlist                     header link (hidden when empty)
     • #wishlist-count                   count inside header link
     • .wish-count                       generic count chip(s)
     • [data-wishlist-grid]              container painted by renderWishlist
        data-wishlist-limit="N"         cap for summary grids
     • [data-wishlist-empty]             text shown when count = 0
     • [data-wishlist-empty-card]        card shown when count = 0
     • [data-wishlist-grid-card]         card shown when count > 0
     • [data-wishlist-addall]            "Add all to bag" button
     • [data-wishlist-browse]            "Browse products" link (shown when empty)
     • [data-wishlist-more-link]         sidebar "All N" / "Browse" link

   Storage is browser-only — no cross-device sync, no logged-in
   persistence. Swap the read/write internals for a backend API
   (e.g. Rivo Wishlist app) when one is installed.
   ============================================================ */
(function(){
  'use strict';
  if (window.__pmWishlistBound) return;
  window.__pmWishlistBound = true;

  var KEY = 'pm:wishlist:saved';

  // Dev / debug — visit any page with ?wishlist-reset=1 to wipe localStorage.
  try {
    if (window.location.search.indexOf('wishlist-reset=1') !== -1) {
      localStorage.removeItem(KEY);
      console.log('[Wishlist] cleared via ?wishlist-reset=1');
    }
  } catch (e) {}

  function read(){
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(arr){
    try { localStorage.setItem(KEY, JSON.stringify(arr || [])); }
    catch (e) { console.warn('[Wishlist] write failed:', e); }
  }
  function indexOfId(arr, pid){
    for (var i = 0; i < arr.length; i++) {
      if (parseInt(arr[i].id, 10) === pid) return i;
    }
    return -1;
  }

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function cardHTML(p, idx){
    return '<a class="wish" href="' + esc(p.url || '#') + '" data-wishlist-card data-wishlist-index="' + idx + '" data-product-id="' + esc(p.id) + '"' + (p.variantId ? ' data-variant-id="' + esc(p.variantId) + '"' : '') + '>' +
             (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title || '') + '" loading="lazy">' : '') +
             '<button type="button" class="x" data-wishlist-remove data-wishlist-index="' + idx + '" data-product-id="' + esc(p.id) + '" aria-label="Remove from wishlist">×</button>' +
             (p.price ? '<span class="pr">' + esc(p.price) + '</span>' : '') +
           '</a>';
  }

  function paintAll(){
    var items = read();
    var n = items.length;
    var ids = items.map(function(p){ return parseInt(p.id, 10); });

    // Header link + count
    var headerLink = document.getElementById('nav-wishlist');
    var headerCount = document.getElementById('wishlist-count');
    if (headerLink) {
      headerLink.hidden = n === 0;
      headerLink.setAttribute('data-has-items', n > 0 ? 'true' : 'false');
    }
    if (headerCount) {
      headerCount.textContent = String(n);
      headerCount.hidden = n === 0;
    }

    // Generic count chips (sidebar, etc.)
    document.querySelectorAll('.wish-count').forEach(function(el){
      if (el.id === 'wishlist-count') return;
      el.textContent = String(n);
    });

    // Toggle buttons — set aria-pressed based on saved state
    document.querySelectorAll('[data-wishlist-toggle][data-product-id]').forEach(function(btn){
      var pid = parseInt(btn.dataset.productId, 10);
      var on = pid && ids.indexOf(pid) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Dashboard grids + paired empty/grid card visibility + summary count
    if (typeof window.renderWishlist === 'function') {
      try { window.renderWishlist(items); } catch (e) { console.warn('[Wishlist] renderWishlist threw:', e); }
    }
  }

  window.renderWishlist = function(items){
    if (!Array.isArray(items)) items = [];
    var n = items.length;

    document.querySelectorAll('[data-wishlist-grid]').forEach(function(grid){
      var limit = parseInt(grid.dataset.wishlistLimit, 10) || items.length;
      var slice = items.slice(0, limit);
      grid.innerHTML = slice.map(function(p, i){ return cardHTML(p, i); }).join('');
      grid.hidden = slice.length === 0;
    });

    document.querySelectorAll('[data-wishlist-empty-card]').forEach(function(el){ el.hidden = n > 0; });
    document.querySelectorAll('[data-wishlist-grid-card]').forEach(function(el){ el.hidden = n === 0; });
    document.querySelectorAll('[data-wishlist-empty]').forEach(function(el){ el.hidden = n > 0; });
    document.querySelectorAll('[data-wishlist-addall]').forEach(function(el){ el.hidden = n === 0; });
    document.querySelectorAll('[data-wishlist-browse]').forEach(function(el){ el.hidden = n > 0; });

    document.querySelectorAll('#wishlist-total-count').forEach(function(el){
      el.textContent = n + ' item' + (n === 1 ? '' : 's');
    });
    document.querySelectorAll('[data-wishlist-more-link]').forEach(function(el){
      if (n > 0) {
        el.textContent = 'All ' + n;
        el.setAttribute('href', '#wishlist');
        el.setAttribute('data-view', 'wishlist');
      } else {
        el.textContent = 'Browse';
        el.setAttribute('href', '/collections/all');
        el.removeAttribute('data-view');
      }
    });
  };

  // Build a product object from a toggle button's data-* attributes.
  function productFromButton(btn){
    var d = btn.dataset;
    return {
      id:        parseInt(d.productId, 10) || d.productId,
      title:     d.productTitle || '',
      handle:    d.productHandle || '',
      url:       d.productUrl || (d.productHandle ? '/products/' + d.productHandle : '#'),
      image:     d.productImage || '',
      price:     d.productPrice || '',
      variantId: d.variantId ? (parseInt(d.variantId, 10) || d.variantId) : null
    };
  }

  // Toggle (PDP v2 buy-box heart, cross-sell hearts, etc.)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-toggle][data-product-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var pid = parseInt(btn.dataset.productId, 10);
    if (!pid) return;
    var items = read();
    var i = indexOfId(items, pid);
    var savedNow;
    if (i === -1) {
      items.push(productFromButton(btn));
      savedNow = true;
    } else {
      items.splice(i, 1);
      savedNow = false;
    }
    write(items);

    // Pulse animation
    btn.classList.remove('is-saved-pulse'); void btn.offsetWidth; btn.classList.add('is-saved-pulse');
    var headerLink = document.getElementById('nav-wishlist');
    if (headerLink) { headerLink.classList.remove('is-pulse'); void headerLink.offsetWidth; headerLink.classList.add('is-pulse'); }

    paintAll();
    document.dispatchEvent(new CustomEvent('pm:wishlist:toggle', { detail: { productId: pid, saved: savedNow } }));
  });

  // Remove (× button on each wishlist card)
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-remove]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var items = read();
    var pid = parseInt(btn.dataset.productId, 10);
    var i = pid ? indexOfId(items, pid) : -1;
    // Fallback: use the rendered card index when id is missing/invalid
    if (i === -1) {
      var idx = parseInt(btn.dataset.wishlistIndex, 10);
      if (!isNaN(idx) && idx >= 0 && idx < items.length) i = idx;
    }
    if (i === -1) return;
    items.splice(i, 1);
    write(items);
    paintAll();
    document.dispatchEvent(new CustomEvent('pm:wishlist:toggle', { detail: { productId: pid || null, saved: false } }));
  });

  // "Add all to bag" — POST every variant to /cart/add.js, then open drawer
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-addall]');
    if (!btn) return;
    e.preventDefault();
    var items = read();
    var ids = items.map(function(p){ return p.variantId; }).filter(Boolean);
    if (!ids.length) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding…';
    var body = { items: ids.map(function(id){ return { id: id, quantity: 1 }; }) };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res){ return res.ok ? res.json() : Promise.reject(res); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('pm:cart-drawer:open'));
        var d = document.getElementById('cart-drawer');
        if (d) d.classList.add('active');
      })
      .catch(function(err){ console.warn('[Wishlist] add-all failed:', err); })
      .then(function(){ btn.disabled = false; btn.textContent = orig; });
  });

  // Cross-tab sync
  window.addEventListener('storage', function(e){
    if (e.key !== KEY) return;
    paintAll();
  });

  // Initial paint
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll);
  } else {
    paintAll();
  }
})();
